import type { FC, ReactNode } from "react";
import { createContext } from "react";

import { useNonNullableContext } from "app/common";

import type { ContactsFlowStrategy } from "./ContactsFlowContext.types";

const ContactsFlowContext = createContext<ContactsFlowStrategy | null>(null);
ContactsFlowContext.displayName = "ContactsFlowContext";

type ContactsFlowProviderProps = {
    value: ContactsFlowStrategy;
    children: ReactNode;
};

export const ContactsFlowProvider: FC<ContactsFlowProviderProps> = ({ value, children }) => {
    return <ContactsFlowContext.Provider value={value}>{children}</ContactsFlowContext.Provider>;
};

export const useContactsFlowStrategy = (): ContactsFlowStrategy => useNonNullableContext(ContactsFlowContext);
